import axios, { AxiosResponse } from "axios";
import { getErrorMessage } from '../locales/translationUtils';

interface ApiResponse<T> {
    success: boolean;
    message: string;
    data: T;
}

interface User {
    username: string;
    password: string;
    id: number;
    rememberMe: boolean;
}

interface UserData {
    username: string;
    permission: string;
    id: number;
    /** Usuário entrou com a senha padrão e precisa cadastrar uma senha própria. */
    senhaPadrao?: boolean;
}

const baseUrl: string | undefined = process.env.REACT_APP_BACK_END_AUTH_API_URL;
if (!baseUrl) throw new Error(getErrorMessage('missingEnvVariableError'));

export const login = async (data: User): Promise<UserData> => {
    const url = `${baseUrl}Autenticacao/login`;

    try {
        // rememberMe vai para o servidor porque quem controla a permanencia e o cookie
        // de autenticacao. Antes a opcao morria aqui e a sessao caia sempre no mesmo prazo.
        const response: AxiosResponse<ApiResponse<UserData>> = await axios.post(url, {
            username: data.username,
            password: data.password,
            rememberMe: data.rememberMe,
        }, { withCredentials: true });

        if (response.status === 200) {
            return response.data.data;
        } else {
            throw new Error(getErrorMessage("loginFailedError"));
        }
    } catch (error: any) {
        throw error.response ? error.response : error;
    }
};

/**
 * Encerra a sessao no servidor, invalidando o cookie de autenticacao.
 *
 * Sem esta chamada o cookie continuava valido depois do logout - o que passou a
 * importar de verdade com o "manter conectado", que pode dar dias de validade a ele.
 */
export const logoutService = async (): Promise<void> => {
    const url = `${baseUrl}Autenticacao/logout`;

    await axios.post(url, {}, { withCredentials: true });
};

export const validateSessionService = async (): Promise<User | null> => {
    const url = `${baseUrl}Autenticacao/validateSession`;

    try {
        const response: AxiosResponse<ApiResponse<User>> = await axios.get(url, { withCredentials: true });

        return response.data.data; 
    } catch (error: any) {
        return null; 
    }
};

